import { Box, Stack, Theme } from '@mui/material';
import { CSSProperties, FC } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { createUseStyles } from 'react-jss';
import type { CodeProps } from 'react-markdown/lib/ast-to-react';
import Text from '../text';

const useStyles = createUseStyles((theme: Theme) => ({
  codeBlockHeader: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.gray,
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
  },
  codeBlock: {
    marginBottom: '0px !important',
    marginTop: '0px !important',
    '& code': {
      background: 'transparent !important',
    },
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
  },
  singleLineCodeBlock: {
    backgroundColor: theme.palette.lightGray,
    color: `#D51C3F`,
    padding: '2px 4px',
    borderRadius: 3,
  },
}));

const CodeBlock: FC<CodeProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { children, className, node, inline, ...rest } = props;
  const [, language] = className ? /language-(\w+)/.exec(className) || [] : [];
  const styles = useStyles();
  const isCodeBlock = String(children).split('\n').length > 1;

  if (!language && !isCodeBlock) {
    return (
      <code {...rest} className={styles.singleLineCodeBlock}>
        {children}
      </code>
    );
  }

  const codeContent = String(children).replace(/\n$/, '');

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        className={styles.codeBlockHeader}
        py={0.5}
        px={1.5}
      >
        <Text size="small">{String(language || 'TEXT').toLowerCase()}</Text>
      </Stack>
      <SyntaxHighlighter
        {...rest}
        PreTag="div"
        // eslint-disable-next-line react/no-children-prop
        children={codeContent}
        language={language}
        style={darcula as Record<string, CSSProperties>}
        className={styles.codeBlock}
      />
    </Box>
  );
};

export default CodeBlock;
